import { Instagram, MessageCircle, Mail } from "lucide-react";
import { BRAND, buildWhatsAppUrl } from "../data/watches";
import { Logo } from "./Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--brand-surface)] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-20">
        {/* Massive wordmark */}
        <div className="mb-16">
          <div className="font-serif-rw text-[18vw] sm:text-[14vw] lg:text-[180px] leading-[0.85] tracking-tighter text-slate-50/95 font-light">
            Romero
            <span className="italic text-[var(--brand-gold)]">.</span>
          </div>
          <div className="font-accent-rw text-xs sm:text-sm uppercase tracking-[0.5em] text-slate-400 mt-4">
            Watches · {BRAND.city}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-t border-white/5 pt-12">
          <div className="md:col-span-5">
            <Logo size="sm" />
            <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-sm font-light">
              Selección curada de relojes inspirados en los grandes iconos del
              lujo. Basados en {BRAND.city}, con envíos a todo el mundo.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-[var(--brand-gold)] mb-5">
              Explorar
            </div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><a className="hover:text-[var(--brand-gold)] transition" href="#coleccion" data-testid="footer-link-collection">Colección</a></li>
              <li><a className="hover:text-[var(--brand-gold)] transition" href="#artesania" data-testid="footer-link-craftsmanship">Artesanía</a></li>
              <li><a className="hover:text-[var(--brand-gold)] transition" href="#historia" data-testid="footer-link-history">Historia</a></li>
              <li><a className="hover:text-[var(--brand-gold)] transition" href="#contacto" data-testid="footer-link-contact">Contacto</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-[var(--brand-gold)] mb-5">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>{BRAND.city}</li>
              <li>Envíos a todo el mundo</li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[var(--brand-gold)]" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[var(--brand-gold)] transition" data-testid="footer-email-link">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle size={14} className="text-[var(--brand-gold)]" />
                <a href={buildWhatsAppUrl()} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--brand-gold)] transition" data-testid="footer-whatsapp-link">
                  Escribir por WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram size={14} className="text-[var(--brand-gold)]" />
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--brand-gold)] transition" data-testid="footer-instagram-link">
                  {BRAND.ig}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t border-white/5 font-accent-rw text-[10px] uppercase tracking-[0.28em] text-slate-500">
          <div>© {year} Romero Watches · Todos los derechos reservados</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[var(--brand-gold)] transition" data-testid="footer-link-privacy">Privacidad</a>
            <a href="#" className="hover:text-[var(--brand-gold)] transition" data-testid="footer-link-terms">Términos</a>
            <a href="#" className="hover:text-[var(--brand-gold)] transition" data-testid="footer-link-shipping">Envíos</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
